import * as React from "react"
import { observer } from "mobx-react"
import { LinkContainer } from "react-router-bootstrap"
import * as H from "history"
import { Button } from "reactstrap"
import BaseView from "../BaseView"
import { route } from "../../routes/routes"
import { Routes } from "../../routes/AppRoutes"
import { ApiTableViewAdapter } from "../../components/table-view/ApiTableViewAdapter"
import { QueryWhereClause } from "../../api/ApiClient"
import { ManagedChooseableColumn } from "../../components/table-view/ManagedTableViewColumnChooser";
import ManagedTableView from "../../components/table-view/ManagedTableView";
import SentNotification from '../../models/SentNotification';

type Props = {
  location: H.Location<H.LocationState>,
}

@observer
export default class SentNotificationsView extends BaseView<Props> {
  renderContentHeader (): React.ReactNode | null {
    return (
      <>
        <h1>Notifications</h1>
        <ul className="content-header-actions">
          <li>
            <LinkContainer to={route(Routes.system.sentNotifications.create)}>
              <Button color="primary" onClick={() => {
              }}><i className="fa fa-send"/> Send New Notification</Button>
            </LinkContainer>
          </li>
        </ul>
      </>
    )
  }

  private tableViewRef = React.createRef<ManagedTableView>()

  private availableColumns: ManagedChooseableColumn[] = [
    {
      id: 'createdAt',
      column: {
        accessor: 'createdAt',
        title: 'Sent',
        renderItem: d => d.format('MM/DD/YYYY'),
        sortable: true,
      },
      fixed: true,
    },
    {
      id: 'to',
      column: {
        accessor: 'to',
        title: 'To',
        sortable: true,
      },
      fixed: true,
    },
    {
      id: 'message',
      column: {
        accessor: 'message',
        title: 'Message',
        sortable: true,
      },
      fixed: true,
    },
    {
      id: 'user',
      column: {
        accessor: 'user.username',
        title: 'Sent by',
      },
      fixed: true,
    }
  ]

  private sentNotificationsAdapter = new ApiTableViewAdapter(() => {
      const where: QueryWhereClause[] = []

      return {
        query: `
      sentNotifications {
        *
        user {
          username
        }
      }
    `,
        where: where,
      }
    },
    'sentNotifications',
    SentNotification,
  )

  renderContentBody (): React.ReactNode {
    return this.renderTable()
  }

  private renderTable = () => {
    return <ManagedTableView
      stateKey="SentNotificationsView"
      hideItemCount={true}
      allowShowInactive={false}
      ref={this.tableViewRef}
      adapter={this.sentNotificationsAdapter}
      availableColumns={this.availableColumns}
      defaultSort={{sortKey: 'createdAt', descending: true}}
    />
  }
}
